import { render, staticRenderFns } from "./AddPrice.vue?vue&type=template&id=333955ac&scoped=true&"
import script from "./AddPrice.vue?vue&type=script&lang=js&"
export * from "./AddPrice.vue?vue&type=script&lang=js&"
import style0 from "./AddPrice.vue?vue&type=style&index=0&id=333955ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333955ac",
  null
  
)

export default component.exports